import React from 'react';
import usePlayerSelector from '../../utils/usePlayerSelector';
import PlaylistReport from '../../components/PlaylistReport';
import { useOktaQuery, Playlists } from '../../data';

const MyPlaylists = () => {
    const { PlayerID } = usePlayerSelector();
    const { data: playlists, isLoading } = useOktaQuery(['player-playlists', PlayerID], (t) => Playlists.getPlayerPlaylist(t, PlayerID));

    return <PlaylistReport title="My Playlists" isLoading={isLoading} playlists={playlists} />;
};

export default MyPlaylists;
